export default {"src":"/_next/static/media/vector-two.4438a445.svg","height":172,"width":72};